export default __webpack_public_path__ + "static/media/sort.b2a8fd9c.svg";